import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import CleanEnergyMineralIcon from '../../../icons/CleanEnergyMineralIcon'
import IndustrialMineralsIcon from '../../../icons/IndustrialMineralsIcon'
import SecurityMineralIcon from '../../../icons/SecurityMineralIcon'

const cleanEnergyLinks = [
  { label: 'MINERALS_OVERVIEW', route: 'future-minerals?category=1' },
  { label: 'FUTURE_MINERALS_REGION', route: 'future-minerals/region?category=1' },
  { label: 'ARAB_PRODUCTION', route: 'future-minerals/clean-energy/arab-production' },
  { label: 'VALUE_CHAIN', route: 'future-minerals/value-chains?category=1' },
  { label: 'GLOBAL_DEMAND', route: 'future-minerals/clean-energy/global-demand' },
  { label: 'CLEAN_ENERGY_TECHNOLOGIES', route: 'future-minerals/clean-energy/technologies' },
]

const industrialLinks = [
  { label: 'MINERALS_OVERVIEW', route: 'future-minerals?category=2' },
  { label: 'FUTURE_MINERALS_REGION', route: 'future-minerals/region?category=2' },
  { label: 'ARAB_PRODUCTION', route: 'future-minerals/industrial/arab-production' },
  { label: 'VALUE_CHAIN', route: 'future-minerals/value-chains?category=2' },
  { label: 'MAIN_INDUSTRIES', route: 'future-minerals/industrial/industries' },
]

const securityLinks = [
  { label: 'MINERALS_OVERVIEW', route: 'future-minerals?category=4' },
  { label: 'FUTURE_MINERALS_REGION', route: 'future-minerals/region?category=4' },
  { label: 'ARAB_PRODUCTION', route: 'future-minerals/security/arab-production' },
  { label: 'VALUE_CHAIN', route: 'future-minerals/value-chains?category=4' },
  { label: 'AGRICULTURAL_APPLICATIONS', route: 'future-minerals/security/securities' },
]

export default function NavbarDesktopDropdown({ lng }) {
  const { t } = useTranslation()
  const [isCleanEnergyOpen, setIsCleanEnergyOpen] = useState(false)
  const [isIndustrialOpen, setIsIndustrialOpen] = useState(false)
  const [isSecurityOpen, setIsSecurityOpen] = useState(false)


  const handleToggleCleanEnergy = () => {
    setIsCleanEnergyOpen(!isCleanEnergyOpen)
    setIsIndustrialOpen(false)
    setIsSecurityOpen(false)
  }

  const handleToggleIndustrial = () => {
    setIsIndustrialOpen(!isIndustrialOpen)
    setIsCleanEnergyOpen(false)
    setIsSecurityOpen(false)
  }

  const handleToggleSecurity = () => {
    setIsSecurityOpen(!isSecurityOpen)
    setIsCleanEnergyOpen(false)
    setIsIndustrialOpen(false)
  }

  return (
    <div className="absolute mt-6">
      <div className="border-muted-300 relative border-2 bg-light p-2">
        <ul className="flex flex-col gap-2">
          {/* Clean Energy Minerals */}
          <li>
            <div
              onClick={handleToggleCleanEnergy}
              className={`flex border-2 ${isCleanEnergyOpen ? 'bg-cleanEnergy text-white' : 'bg-white text-cleanEnergy hover:bg-cleanEnergy hover:text-white'} cursor-default items-center border-cleanEnergy`}
            >
              <div className="bg-cleanEnergy p-2">
                <CleanEnergyMineralIcon
                  size={22}
                  color={'#ffff'}
                />
              </div>
              <div className="whitespace-nowrap ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">{t('CLEAN_ENERGY_MINERALS')}</div>
            </div>
            {isCleanEnergyOpen && (
              <div className="border-muted-300 absolute -top-[2px] border-2 bg-light p-2 ltr:left-full ltr:ml-3 rtl:right-full rtl:mr-3">
                <div className="absolute top-6 h-3 w-3 -rotate-45 bg-light ltr:-left-5 ltr:border-b-2 ltr:border-r-2 rtl:-right-5 rtl:border-l-2 rtl:border-t-2" />
                <ul className="flex flex-col gap-2 whitespace-nowrap text-white">
                  {cleanEnergyLinks.map((link) => (
                    <li key={link.label}>
                      <Link
                        className={`border-muted-300 flex border-2 bg-white py-2 text-cleanEnergy hover:border-cleanEnergy hover:bg-cleanEnergy hover:text-white ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4`}
                        to={`/${lng}/${link.route}`}
                      >
                        {t(link.label)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>

          {/* Industrial Minerals */}
          <li>
            <div
              onClick={handleToggleIndustrial}
              className={`flex border-2 ${isIndustrialOpen ? 'bg-industrial text-white' : 'bg-white text-industrial hover:bg-industrial hover:text-white'} cursor-default items-center border-industrial`}
            >
              <div className="bg-industrial p-2">
                <IndustrialMineralsIcon
                  size={22}
                  color={'#ffff'}
                />
              </div>
              <div className="whitespace-nowrap ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">{t('INDUSTRIAL_MINERALS')}</div>
            </div>
            {isIndustrialOpen && (
              <div className="border-muted-300 absolute -top-[2px] border-2 bg-light p-2 ltr:left-full ltr:ml-3 rtl:right-full rtl:mr-3">
                <div className="absolute top-[72px] h-3 w-3 -rotate-45 bg-light ltr:-left-5 ltr:border-b-2 ltr:border-r-2 rtl:-right-5 rtl:border-l-2 rtl:border-t-2" />
                <ul className="flex flex-col gap-2 whitespace-nowrap text-white">
                  {industrialLinks.map((link) => (
                    <li key={link.label}>
                      <Link
                        className={`border-muted-300 flex border-2 bg-white py-2 text-industrial hover:border-industrial hover:bg-industrial hover:text-white ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4`}
                        to={`/${lng}/${link.route}`}
                      >
                        {t(link.label)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>

          {/* FOOD Minerals */}
          <li>
            <div
              onClick={handleToggleSecurity}
              className={`flex border-2 ${isSecurityOpen ? 'bg-security text-white' : 'bg-white text-security hover:bg-security hover:text-white'} cursor-default items-center border-security`}
            >
              <div className="bg-security p-2">
                <img
                  src="/assets/icons/security-color-header/security-food-icon.svg"
                  alt=""
                  className="h-5 w-5"
                />
              </div>
              <div className="whitespace-nowrap ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4">{t('FOOD_SECURITY_MINERALS')}</div>
            </div>
            {isSecurityOpen && (
              <div className="border-muted-300 absolute -top-[2px] border-2 bg-light p-2 ltr:left-full ltr:ml-3 rtl:right-full rtl:mr-3">
                <div className="absolute top-[122px] h-3 w-3 -rotate-45 bg-light ltr:-left-5 ltr:border-b-2 ltr:border-r-2 rtl:-right-5 rtl:border-l-2 rtl:border-t-2" />
                <ul className="flex flex-col gap-2 whitespace-nowrap text-white">
                  {securityLinks.map((link) => (
                    <li key={link.label}>
                      <Link
                        className={`border-muted-300 flex border-2 bg-white py-2 text-security hover:border-security hover:bg-security hover:text-white ltr:pl-4 ltr:pr-8 rtl:pl-8 rtl:pr-4`}
                        to={`/${lng}/${link.route}`}
                      >
                        {t(link.label)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        </ul>
        <div className="absolute -top-2 h-3 w-3 rotate-45 border-l-2 border-t-2 bg-light ltr:left-14 rtl:right-14" />
      </div>
    </div>
  )
}
